module.exports = __webpack_public_path__ + "media/images/admin/icons/menu-644fa295fdd5f662e642ba6bfb084239.svg";